import React from 'react'
import letterCoverIcon from '../../assets/Icons/Letter-cover-icon.svg';
import whatsAppIcon from '../../assets/Icons/Whatsapp-Icons.svg';
import messageIcon from '../../assets/Icons/Message-icon.svg';
import refreshIcon from '../../assets/Icons/refresh-icon.svg';
import rightArroeIcon from '../../assets/Icons/rightArrow-icon.svg'
import { useNavigate } from 'react-router-dom';

const ActionTool = ({filteredLeadCount, leadId}) => {
  console.log(leadId)
  const userData = JSON.parse(localStorage.getItem("userData"));
  const userRole = userData?.user?.role;
  const navigate = useNavigate();

  const handleOpenAssignToTeam =()=>{

    // if()
    if(userRole === "Admin" ){

      navigate("/admin/leadSplit-teamWise",{state: {filteredCount: filteredLeadCount, leadId: leadId}});
      }else if (userRole === "CMO"){

        navigate('/cmo/leadSplit-teamWise', {state: {filteredCount: filteredLeadCount, leadId: leadId}})
      }
     };
  return (
    <>
    <div className='w-full p-10 h-full bg-white   shadow-md rounded-md  flex flex-col'>
      <h1 className='text-center text-2xl font-semibold pt-4'>Action Tools</h1>


      <div className='flex flex-col gap-5 mt-7' >
      <div className=' h-16 shadow-md rounded-lg mt-4 '>
        <p className='flex justify-between px-8 py-4 text-2xl'>Total Actionable Leads: <span className='font-medium text-2xl pr-10'>{filteredLeadCount || 0}</span></p>
      </div>


        <div className='flex justify-between  h-14 shadow-md rounded-lg px-4 items-center'>

        <img src={letterCoverIcon} alt="" />
        <h1 className='text-xl text-center font-medium  whitespace-nowrap'>Bulk Email Tool</h1>
        <img src={rightArroeIcon} className='' alt="" />
        </div>

        <div className='flex justify-between w-full h-14 shadow-md rounded-lg px-4  items-center'>

        <img src={whatsAppIcon} alt="" />
        <h1 className='text-xl text-center font-medium whitespace-nowrap'>Bulk WhatsApp Message Tool</h1>
        <img src={rightArroeIcon} className='' alt="" />
        </div>
        <div className='flex justify-between  h-14 shadow-md rounded-lg px-4 items-center'>

        <img src={messageIcon} alt="" />
        <h1 className='text-xl font-medium text-center'>Bulk SMS Tool</h1>
        <img src={rightArroeIcon} className='' alt="" />
        </div>
        <div className='flex justify-between  h-14 shadow-md px-4 rounded-lg items-center cursor-pointer'
        onClick={handleOpenAssignToTeam}>

        <img src={refreshIcon} alt="" />
        <h1 className='text-xl font-medium text-center '>Assign to Other teams</h1>
        <img src={rightArroeIcon} className='' alt="" />
        </div>



      </div>
    </div>
    </>
  )
}

export default ActionTool
